@if (product$ | async; as product) {
<div class="row product-details-top-line justify-content-end">
  <div class="col-lg-12">
    <ul class="share-tools">
      <ng-container *ishFeature="'wishlists'">
        @if (configuration$('addToWishlist') | async) {
        <li [attr.data-testing-id]="'wishlist-' + product.sku">
          <ish-lazy-product-add-to-wishlist [displayType]="'icon'" />
        </li>
        }
      </ng-container>
      <ng-container *ishFeature="'compare'">
        @if (configuration$('addToCompare') | async) {
        <li [attr.data-testing-id]="'compare-' + product.sku">
          <ish-lazy-product-send-to-compare />
        </li>
        }
      </ng-container>
      <li>
        <a
          href="javascript:window.print();"
          class="link-print"
          rel="nofollow"
          [title]="'product.print_page.link' | translate"
        >
          <fa-icon [icon]="['fas', 'print']" />
        </a>
      </li>
      <li>
        <a
          href="mailto:
          ?subject={{ 'email.recommended_product.heading' | translate : { '0': channelName } }}
          &body={{ 'email.recommended_product.text' | translate : { '0': product.name + '%0A', '1': document.URL } }}"
          [title]="'product.email_a_friend.link' | translate"
        >
          <fa-icon [icon]="['fas', 'share-alt']" />
        </a>
      </li>
    </ul>
  </div>
</div>
}
